import { store } from "@betacrew/jars-flux";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { componentKey, setFederalForms, setFederalPayers, setFederalPayersLoader, setFederalTaxYear, setFederalTaxYearsLoader, setLoadingState, setManageFormsLoad, setStateForms } from "./ManageFormsSlice";
import { PAGE_STATE } from "../../constants/constants";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import ManageFormsService from "../../../../services/ManageFormsService";
import GeneralDataService from "../../../../services/GeneralDataService";
import General from "../../../../libs/utility/General";
import { MANAGE_FORMS_LOADING_STATES } from "./constants";

export const { getFederalPayers, getTaxYears, getFederalForms } = {
    getFederalPayers: (payload) => {
        return {
            type: "MANAGE_FORMS/GET_FEDERAL_PAYERS",
            payload
        }
    },

    getTaxYears: (payload) => {
        return {
            type: "MANAGE_FORMS/GET_FEDERAL_TAX_YEARS",
            payload
        }
    },

    getFederalForms: (payload) => {
        return {
            type: "MANAGE_FORMS/GET_FEDERAL_FORMS",
            payload
        }
    },

}

function* getFederalPayersAsync() {
    try {
        yield put(setFederalPayersLoader({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }))

        const response = yield ManageFormsService.getFederalPayers()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId")
            const Payers = Data.map(item => { return { ...item, checked: false } })
            yield put(setFederalPayers(Payers))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch federal payers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch federal payers", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFederalPayersLoader({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getTaxYearsAsync() {
    try {
        yield put(setFederalTaxYearsLoader({ state: MANAGE_FORMS_LOADING_STATES.TAX_YEARS_LOADING }))

        const response = yield GeneralDataService.getTaxYears()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "ID", "ID")
            yield put(setFederalTaxYear(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch tax year", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch tax year", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFederalTaxYearsLoader({ state: MANAGE_FORMS_LOADING_STATES.TAX_YEARS_READY }))
    }
}

function* getFederalFormsAsync() {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }))

        const response = yield ManageFormsService.getFederalForms()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "FormName1", "FormId")

            const $94X_Category = ["940", "941", "943", "944", "945", "941x", "941PR", "1042", "8027", "944x"];
            const $1099_FORMS = Data.filter(item => !$94X_Category.includes(item?.FormName1));
            yield put(setFederalForms($1099_FORMS))
            yield put(setManageFormsLoad(General.filterFormsByName(Data, $94X_Category)))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch federal forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch federal forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFederalPayers().type, getFederalPayersAsync),
        takeLatest(getTaxYears().type, getTaxYearsAsync),
        takeLatest(getFederalForms().type, getFederalFormsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);